import EventBus from 'diagram-js/lib/core/EventBus';
import {TrackingChangeBaseBehavior} from '@ispm-client/modules/bpmn-modeler/bpmn/tracking-changes/tracking-change-base-behavior';
import {BpmnExtensionHelper} from '@ispm/shared/bpmn-io/bpmn-extension-helper';
import {CommandType} from '@ispm/shared/bpmn-io/bpmn-js';
import {ModelingUtil} from "@ispm/shared/bpmn-io/modeling-util";

export class MarkNodeAddedBehavior extends TrackingChangeBaseBehavior  {

    constructor(eventBus: EventBus, moddle, modeling, bpmnExtensionHelper: BpmnExtensionHelper) {
        super(eventBus, moddle, modeling, bpmnExtensionHelper);
        super.postExecuted([CommandType.APPEND_NODE], this.markElementForChange.bind(this));
    }

    getChangeType() {
        return 'added';
    }

    extractElementsFromEvent(event) {
      const node = event.context.node;
      if(node){
        const incomingConnection = ModelingUtil.getNodeIncomingConnections(node)[0];
        const incomingShape = incomingConnection.source;
        if (ModelingUtil.isGateway(incomingShape)) {
          const incomingConnectionForGateway = ModelingUtil.getNodeIncomingConnections(incomingShape)[0];
          return [incomingConnectionForGateway,incomingConnection,node];
        }
        return [incomingConnection,node];
      }
    }
}
